// extracted by mini-css-extract-plugin
export default {"grid":"Background_grid__bDUGL","tall":"Background_tall__uF1Hz","block":"Background_block__n1Oct","bullets":"Background_bullets__CkxF-"};